













import { Component, Mixins } from 'vue-property-decorator';
import { AxTransparent } from '@/mixins';

@Component
export default class AxowAligned extends Mixins(AxTransparent) {}
